import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import * as styles from "./styles.module.css";

/**
 * DeckIconContent component
 * This component renders a section with image content.
 * @param {Object} data - The data for the section.
 */
const DeckIconContent = ({ data }) => {
    const { customId, id, title, description, additionalConfiguration, backgroundColor, cardItems = [] } = data ?? {};
    // Determine section classes based on the presence of background and icon content
    const sectionSpacingClassName = getSpacingClassName(
        additionalConfiguration,
        "py-15 md:py-20 lg:py-30 lg:pb-[134px]"
    );
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    // Render the section with icon content
    return (
        <section
            data-section
            id={customId || id}
            className={`icon-content-section overflow-hidden ${sectionColorMapping.bgColor ||
                "bg-stone-light"} ${sectionSpacingClassName}`}
        >
            <div className="container">
                <div className="row">
                    <div className="section-content">
                        {/* Render the title if it exists */}
                        {title && <h2 className="mb-4 title-2 text-center lg:tracking-tight10">{title}</h2>}
                        {/* Render the description if it exists */}
                        {description?.description && (
                            <div className="text-center flex justify-center">
                                <p className={`text-md sm:text-2xl font-light leading-relaxed tracking-tight6 `}>
                                    {description?.description}
                                </p>
                            </div>
                        )}
                        {/* Render the cards */}
                        <div className={`cards gap-x-7.5 pt-0 md:pt-3.75 lg:pt-11.25 flex flex-wrap justify-center `}>
                            {cardItems?.map((card) => (
                                <div key={card.id} className="card-item mt-8.5 lg:mt-8.5 md:max-w-80 lg:max-w-92.5">
                                    {/* Render the media if it exists */}
                                    <div className="flex justify-center max-h-[243px]">
                                        {card?.media?.[0] && (
                                            <Media
                                                media={card?.media?.[0]}
                                                className="w-auto max-h-12 rounded ax-w-12"
                                            />
                                        )}
                                    </div>
                                    {/* Render the card title if it exists */}
                                    {card?.title && (
                                        <h3 className="title-4 text-center line-clamp-3 mt-3.75">{card?.title}</h3>
                                    )}
                                    {/* Render the card description if it exists */}
                                    {card?.description?.description && (
                                        <p className={`card-description mt-3.75 text-center line-clamp-6 lg:px-3.5 `}>
                                            {card?.description?.description}
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default DeckIconContent;
